<template>
  <div v-if="groups">
    <!-- {{ groups }} -->
    <div v-for="lv in groups" :key="lv.key">
      <Level :level="lv" @click="s2Click" />
    </div>
  </div>
</template>

<style scoped>
.van-col {
  font-size: 0.8rem;
  /* font-weight: bold; */
  color: grey;
}
.el-button {
  font-size: 1rem;
}
</style>

<script>
import Level from "./Level.vue";

export default {
  components: {
    Level,
  },
  props: {
    groups: Array,
  },
  data() {
    return {};
  },
  methods: {
    s2Click(item) {
      this.$emit("click", item);
    },
    // clearLv(lv, item) {
    //   //檢查是否有超過數量
    //   if (lv.limit == 1) {
    //     if (item.Qty) {
    //       lv.options.map((r) => {
    //         if (r.ItemName != item.ItemName) {
    //           r.Qty = 0;
    //           // console.log(lv.id, r.ItemName);
    //           this.clear(r); //遞迴往下清除
    //         }
    //       });
    //     }
    //   }
    // },
    // onChange(item) {
    //   console.log("onChange", item);
    //   if (item.Qty) {
    //     if (item.Groups.length > 0) {
    //       this.$emit("click", item);
    //     }
    //   } else {
    //     this.clear(item);
    //   }
    // },
    // clear(item) {
    //   item.Groups.map((lv) => {
    //     lv.options.map((r) => {
    //       r.Qty = 0;
    //       this.clear(r); //遞迴往下清除
    //     });
    //   });
    // },
    // getGroupsText(g) {
    //   if (g.length == 0 || g == undefined) {
    //     return "";
    //   }
    //   var array = [];
    //   g.forEach((r) => {
    //     array.push(r.text);
    //   });

    //   return array.join(" / ");
    // },
  },
};
</script>
